// eslint-disable
// this is an auto generated file. This will be overwritten

export const createInspection = `mutation CreateInspection($input: CreateInspectionInput!) {
  createInspection(input: $input) {
    id
    uId
    vId
    date
    odometer
    status
    metadata
    items
  }
}
`;
export const updateInspection = `mutation UpdateInspection($input: UpdateInspectionInput!) {
  updateInspection(input: $input) {
    id
    uId
    vId
    date
    odometer
    status
    metadata
    items
  }
}
`;
export const deleteInspection = `mutation DeleteInspection($input: DeleteInspectionInput!) {
  deleteInspection(input: $input) {
    id
    uId
    vId
    date
    odometer
    status
    metadata
    items
  }
}
`;
export const createVehicle = `mutation CreateVehicle($input: CreateVehicleInput!) {
  createVehicle(input: $input) {
    id
    uId
    recentInspectionId
    data
  }
}
`;
export const updateVehicle = `mutation UpdateVehicle($input: UpdateVehicleInput!) {
  updateVehicle(input: $input) {
    id
    uId
    recentInspectionId
    data
  }
}
`;
export const deleteVehicle = `mutation DeleteVehicle($input: DeleteVehicleInput!) {
  deleteVehicle(input: $input) {
    id
    uId
    recentInspectionId
    data
  }
}
`;
export const createPhoto = `mutation CreatePhoto($input: CreatePhotoInput!) {
  createPhoto(input: $input) {
    id
    key
    file {
      bucket
      region
      key
      mimeType
      localUri
    }
  }
}
`;
export const updatePhoto = `mutation UpdatePhoto($input: UpdatePhotoInput!) {
  updatePhoto(input: $input) {
    id
    key
    file {
      bucket
      region
      key
      mimeType
      localUri
    }
  }
}
`;
export const deletePhoto = `mutation DeletePhoto($input: DeletePhotoInput!) {
  deletePhoto(input: $input) {
    id
    key
    file {
      bucket
      region
      key
      mimeType
      localUri
    }
  }
}
`;
export const createUser = `mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    id
    uId
    tier
    dateCreated
    inspectionsLimit
    vehiclesLimit
    metadata
  }
}
`;
export const updateUser = `mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
    uId
    tier
    dateCreated
    inspectionsLimit
    vehiclesLimit
    metadata
  }
}
`;
export const deleteUser = `mutation DeleteUser($input: DeleteUserInput!) {
  deleteUser(input: $input) {
    id
    uId
    tier
    dateCreated
    inspectionsLimit
    vehiclesLimit
    metadata
  }
}
`;
export const createCustomInspection = `mutation CreateCustomInspection($input: CreateCustomInspectionInput!) {
  createCustomInspection(input: $input) {
    id
    uId
    type
    fallback
    items
  }
}
`;
export const updateCustomInspection = `mutation UpdateCustomInspection($input: UpdateCustomInspectionInput!) {
  updateCustomInspection(input: $input) {
    id
    uId
    type
    fallback
    items
  }
}
`;
export const deleteCustomInspection = `mutation DeleteCustomInspection($input: DeleteCustomInspectionInput!) {
  deleteCustomInspection(input: $input) {
    id
    uId
    type
    fallback
    items
  }
}
`;
